// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__utbjD","container":"styles_container__gIfuo","title":"styles_title__1d-FP","imageContainer":"styles_imageContainer__3eeCK"};